import {
  CountryIntelligenceTeamMemberSeniority,
  EngagementSeniorityLevelType,
} from "@oysterhr/schema"

export const orderedSeniorityLevels = [
  EngagementSeniorityLevelType.Junior,
  EngagementSeniorityLevelType.Mid,
  EngagementSeniorityLevelType.Senior,
  EngagementSeniorityLevelType.Principal,
  EngagementSeniorityLevelType.Lead,
  EngagementSeniorityLevelType.Director,
  EngagementSeniorityLevelType.Head,
  EngagementSeniorityLevelType.Vp,
  EngagementSeniorityLevelType.Csuite,
]

export const mapSeniorityLevelToKBType = {
  [EngagementSeniorityLevelType.Csuite]: CountryIntelligenceTeamMemberSeniority.Csuite,
  [EngagementSeniorityLevelType.Director]: CountryIntelligenceTeamMemberSeniority.Director,
  [EngagementSeniorityLevelType.Head]: CountryIntelligenceTeamMemberSeniority.Head,
  [EngagementSeniorityLevelType.Junior]: CountryIntelligenceTeamMemberSeniority.Junior,
  [EngagementSeniorityLevelType.Lead]: CountryIntelligenceTeamMemberSeniority.Lead,
  [EngagementSeniorityLevelType.Mid]: CountryIntelligenceTeamMemberSeniority.Mid,
  [EngagementSeniorityLevelType.Principal]: CountryIntelligenceTeamMemberSeniority.Principal,
  [EngagementSeniorityLevelType.Senior]: CountryIntelligenceTeamMemberSeniority.Senior,
  [EngagementSeniorityLevelType.Vp]: CountryIntelligenceTeamMemberSeniority.Vp,
}
